<script>
  import Label from "./Label.svelte";
  import { nanoid } from "nanoid";
  import clsx from "clsx";

  let className = "my-4";
  export { className as class };
  export let label;
  export let value;
  export let readonly;
  export let required = false;
  export let type = "text";

  const id = "input-" + nanoid();

  function onInput(event) {
    const target = event.target;
    return (value = type.match(/^(number|range)$/) ? target.valueAsNumber : target.value);
  }
</script>

<div class={clsx(className)}>
  <Label {id} {label} {required} />
  <input {id} class="form-input w-full" {required} {type} {value} {readonly} on:input={onInput} />
</div>
